import React from 'react';
import { MarkerLayerRaw } from './MarkerLayer';
import MarkerClusterLayer from './MarkerClusterLayer'
import TopojsonLayer from './TopojsonLayer';

class BorderLayer extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    let url = '/topojson/bundeslaender_hq.topo.json';
    let featureIndex = 0;
    if (['de', 'at', 'ch'].indexOf(this.props.adminId) !== -1) {
      url = '/topojson/'+this.props.adminId+'.topo.json';
    }

    const regions = [
      'baden-wuerttemberg', //0
      'bayern', //1
      'berlin', //2
      'brandenburg', //3
      'bremen', //4
      'hamburg', //5
      'hessen', //6
      'mecklenburg-vorpommern', //7
      'niedersachsen', //8
      'nordrhein-westfalen', //9
      'rheinland-pfalz', //10
      'saarland', //11
      'sachsen-anhalt', //12
      'sachsen', //13
      'schleswig-holstein', //14
      'thueringen', //15
    ];


    if (regions.indexOf(this.props.adminId) !== -1) {
      featureIndex = regions.indexOf(this.props.adminId);
    }

    return <div>
      <TopojsonLayer
        url={url}
        featureIndex={featureIndex}
        style={{ color: '#000', fill: false, weight: 3, opacity: 1 }}
      />
      </div>;
  }
}

export default BorderLayer;



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/BorderLayer.js
 **/